import React from 'react';
import { HeroUrlInput } from './HeroUrlInput';
import { MetricCards } from './MetricCards';
import { Charts } from './Charts';
import { BacklinkKanban } from './BacklinkKanban';
import { BacklinkTimeline } from './BacklinkTimeline';
import { LayoutDashboard, Settings, User, Bell } from 'lucide-react';
export function SEODashboard() {
  return <div className="min-h-screen w-full bg-[#0f0f0f] text-white font-sans selection:bg-amber-500/30" data-id="element-102">
      {/* Background Gradients */}
      <div className="fixed inset-0 pointer-events-none" data-id="element-103">
        <div className="absolute top-0 left-0 w-full h-[500px] bg-gradient-to-b from-[#1a1a1a] to-transparent opacity-50" data-id="element-104" />
        <div className="absolute bottom-0 right-0 w-[800px] h-[800px] bg-amber-900/10 rounded-full blur-[120px]" data-id="element-105" />
      </div>

      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 border-b border-white/5 bg-[#0f0f0f]/80 backdrop-blur-md" data-id="element-106">
        <div className="max-w-[1600px] mx-auto px-6 h-16 flex items-center justify-between" data-id="element-107">
          <div className="flex items-center gap-2" data-id="element-108">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-amber-400 to-amber-600 flex items-center justify-center text-black font-bold text-lg" data-id="element-109">
              S
            </div>
            <span className="font-bold text-xl tracking-tight" data-id="element-110">
              SEO<span className="text-amber-500" data-id="element-111">Master</span>
            </span>
          </div>

          <div className="flex items-center gap-6" data-id="element-112">
            <button className="text-white/60 hover:text-white transition-colors" data-id="element-113">
              <LayoutDashboard className="w-5 h-5" data-id="element-114" />
            </button>
            <button className="text-white/60 hover:text-white transition-colors relative" data-id="element-115">
              <Bell className="w-5 h-5" data-id="element-116" />
              <span className="absolute top-0 right-0 w-2 h-2 bg-amber-500 rounded-full border-2 border-[#0f0f0f]" data-id="element-117" />
            </button>
            <button className="text-white/60 hover:text-white transition-colors" data-id="element-118">
              <Settings className="w-5 h-5" data-id="element-119" />
            </button>
            <div className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center border border-white/10" data-id="element-120">
              <User className="w-4 h-4 text-white/70" data-id="element-121" />
            </div>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main className="relative z-10 pt-20 pb-12 px-6 max-w-[1600px] mx-auto" data-id="element-122">
        <HeroUrlInput data-id="element-123" />

        <div className="mt-12 space-y-8" data-id="element-124">
          <MetricCards data-id="element-125" />

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6" data-id="element-126">
            {/* Left Column - Kanban (Wider) */}
            <div className="lg:col-span-8" data-id="element-127">
              <BacklinkKanban data-id="element-128" />
            </div>

            {/* Right Column - Charts & Timeline */}
            <div className="lg:col-span-4 space-y-6" data-id="element-129">
              <Charts data-id="element-130" />
              <BacklinkTimeline data-id="element-131" />
            </div>
          </div>
        </div>
      </main>
    </div>;
}